export const surveysHistorySelector = state => state.surveysHistory;
